import React, { useEffect, useState } from "react";
import { isIOS, getDeviceType } from "lib/deviceInfo";
import IOSHomeScreenIcon from "icon/IOSHomeScreenIcon";
import IOSShareIcon from "icon/IOSShareIcon";
import CommonSnackbarView from "presentational/common/CommonSnackbarView";
import TXT from "presentational/common/multinational/TXT";
import { withStore } from "store/storeHandler";
import PropTypes from "prop-types";
import config from "lib/fr-config";

const zIndexOfSnackbar = config.css.zIndex.snackbar.installGuideForIOS;

const cssForIOS = {
  message: { paddingBottom: 10 },
  descList: { display: "flex", alignItems: "center" },
  iosIcon: { display: "flex", padding: "8px 20px" }
};

InstallGuideForIOS.propTypes = {
  readyToShow: PropTypes.bool.isRequired
};

function InstallGuideForIOS(props) {
  const { readyToShow, hasLoggedIn } = props;
  const [isIPhone, setIsIPhone] = useState(false);
  const [isDisplayStandalone, setIsDisplayStandalone] = useState(false);
  const [hideSnackbar, setHideSnackbar] = useState(false);

  useEffect(() => {
    if (!hasLoggedIn) return undefined;

    checkDisplayIsStandalone();
  }, [hasLoggedIn]);

  const checkDisplayIsStandalone = () => {
    if (getDeviceType() === "desktop" || !isIOS) {
      return null;
    } else {
      setIsIPhone(true);
    }

    if ("standalone" in window.navigator && window.navigator.standalone) {
      setIsDisplayStandalone(true);
    }
  };

  const getContent = () => {
    return (
      <div>
        <div style={cssForIOS.message}>
          <TXT name="msg_PWARecommendation" />
        </div>
        <div style={cssForIOS.descList}>
          <span style={cssForIOS.iosIcon}>
            <IOSShareIcon modern />
          </span>
          <TXT name="msg_installStep1" />
        </div>
        <div style={cssForIOS.descList}>
          <span style={cssForIOS.iosIcon}>
            <IOSHomeScreenIcon modern />
          </span>
          <TXT name="msg_installStep2" />
        </div>
      </div>
    );
  };

  const needOpen = () => {
    const open =
      isIPhone && !isDisplayStandalone && !hideSnackbar && readyToShow;
    return open;
  };

  const handleClose = () => {
    setHideSnackbar(true);
  };

  return (
    <CommonSnackbarView
      open={needOpen()}
      contentComponent={getContent()}
      buttonInfoArray={[
        {
          color: "primary",
          func: handleClose,
          btnText: <TXT name="btnSnackbar_gotIt" />
        }
      ]}
      zIndexOfSnackbar={zIndexOfSnackbar}
    />
  );
}

export default withStore({
  stateMap: { myAccount: ["hasLoggedIn"] }
})(InstallGuideForIOS);
